import HomePage from "./HomeContainer";

export default HomePage;
